import { Moment } from 'moment-timezone'
import { FilterField, FilterValues, isRangeValue } from './types'

const formatBound = (
  field: FilterField,
  value: Moment,
  bound: 'from' | 'to'
): string => {
  if (field.kind === 'timeRange') return value.format('HH:mm:ss')
  if (field.kind === 'dateRange') {
    const day = value.clone()
    return (
      bound === 'from' ? day.startOf('day') : day.endOf('day')
    ).toISOString()
  }
  if (field.kind === 'dateTimeRange') {
    const minute = value.clone()
    return (
      bound === 'from' ? minute.startOf('minute') : minute.endOf('minute')
    ).toISOString()
  }
  return value.toISOString()
}

export const serializeFilters = (
  fields: FilterField[],
  values: FilterValues
): Record<string, string> => {
  const params: Record<string, string> = {}

  fields.forEach((field) => {
    const value = values[field.id]

    if (field.kind === 'text') {
      const trimmed = typeof value === 'string' ? value.trim() : ''
      if (trimmed) params[field.id] = trimmed
      return
    }

    if (field.kind === 'select') {
      const selected = typeof value === 'string' ? value : ''
      if (selected) params[field.id] = selected
      return
    }

    if (!isRangeValue(value)) return

    if (value.from?.isValid() && field.fromParam)
      params[field.fromParam] = formatBound(field, value.from, 'from')
    if (value.to?.isValid() && field.toParam)
      params[field.toParam] = formatBound(field, value.to, 'to')
  })

  return params
}
